 // 显示和隐藏增添面试官列表MODAL
export const SHOW_ADDINTERVIEW_MODAL = "SHOW_ADDINTERVIEW_MODAL";
export const HIDE_ADDINTERVIEW_MODAL = "HIDE_ADDINTERVIEW_MODAL";
//  发送请求开始和结束
export const START_ADDINTERVIEW_MODAL = "START_ADDINTERVIEW_MODAL";
export const DONE_ADDINTERVIEW_MODAL = "DONE_ADDINTERVIEW_MODAL";
//   面试官列表table 
export const ADD_INTERVIEW_DATA = "ADD_INTERVIEW_DATA";
// 选择的结果（面试官列表）
export const ADD_TAGLIST = "ADD_TAGLIST";








// WEBPACK FOOTER //
// ./src/constants/addInterview.js